<template>
  <landing-page
    label="insurer.insurer"
    description="insurer.insurerDesc"
    labelColor="#82488F"
    descColor="#82488F"
    :eggImgObj="{ componentName: 'insurer', imgName: 'insurerIntro', imgFormat: 'svg' }"
    :starBackgroundObj="{ componentName: 'shared', imgName: 'starGroupIconPurpleRight', imgFormat: 'svg' }"
    class="mb-10"
  />
  <!--<TitleWStar title="insurer.insurer" 
  titleColor="sea-blue" 
  :starIconObj="{ componentName: 'telemedicine', imgName: 'starIconLightBlue', imgFormat: 'svg' }" 
  />
  change obj to constant?-->
</template>

<script setup lang="ts">
import { useInsurerStore } from "@/stores/insurer";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const insurerStore = useInsurerStore();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>